<div class="checkin__sidebar__wrapper" [ngClass]="{ 'checkin__sidebar__wrapper--status' : isStatusCustomTemplate && project != 'checkout' }">
  <app-booking-detail
    [isResponsive]="isResponsive"
    [showCreditCard]="showCreditCard"
    [ngClass]="{ 'checkin_sidebar_detail--full-height' : !showCreditCard }">
  </app-booking-detail>
  <app-booking-card
    class="outside"
    *ngIf="(showCreditCard && !isResponsive)">
  </app-booking-card>
</div>
